import {animate, keyframes, style, transition, trigger} from '@angular/animations';

export const FADE_IN_ERROR = trigger('fadeInError', [
  transition(':enter', [
    animate('.2s', keyframes([
      style({opacity: 0, transform: 'translateY(-5px)'}),
      style({opacity: 1, transform: 'translateY(0)'}),
    ])),
  ]),
]);


export const FADE_OUT_ERROR = trigger('fadeOutError', [
  transition(':leave', [
    animate('.2s', keyframes([
      style({opacity: 1}),
      style({opacity: 0}),
    ])),
  ]),
]);


export const FADE_IN_ERROR_ION = trigger('fadeInErrorIon', [
  transition(':enter', [
    animate('.1s', keyframes([
      style({opacity: 0}),
      style({opacity: 1}),
    ])),
  ]),
]);


export const FADE_OUT_ERROR_ION = trigger('fadeOutErrorIon', [
  transition(':leave', [
    animate('.1s', keyframes([
      style({opacity: 1}),
      style({opacity: 0}),
    ])),
  ]),
]);
